import {utilityServicesPath} from "../../Constants";
import axios from "axios";
import {TEXTURE_PICTURE_SYSTEM_TYPE} from "../../data/OrganizationCompositionPictureSystemType";

const restUrl = utilityServicesPath + '/organization/media'

export default class OrganizationMediaService {
    static getFormData(selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        return formData;
    }

    static async addPictures(data, file) {
        const params = {
            name: data?.name,
            pictureType: "PICTURE",
            pictureSystemType: data?.pictureSystemType,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return await axios.post(`${restUrl}/pictures?${queryString}`, OrganizationMediaService.getFormData(file));
    }

    /** POST …/organization/media/pictures — pictureSystemType=TEXTURE (Swagger utility). */
    static async addTexturePicture(name, file) {
        return OrganizationMediaService.addPictures(
            {name, pictureSystemType: TEXTURE_PICTURE_SYSTEM_TYPE},
            file,
        );
    }
}